import { useEffect, useState } from "react";
import Collection_dropdown2 from "../dropdown/collection_dropdown2";
import { getAllSubCampaign } from "../../services/campaign";
import { errorToast } from "../../utils/toast";
import { getCategory } from "../../services/vetting";
import Link from "next/link";
import Image from "next/image";
export const baseURL = `${process.env.BASE_URL}/`;

function ViewSubCampaigns({ id }) {
  const [campaign, setCampaign] = useState([]);
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const [filter, setFilter] = useState({
    subCampaign: [
      {
        id: 0,
        text: "All",
        image: "/images/avatars/collection_ava_1.png",
      },
    ],
    impactCategory: [
      {
        id: 0,
        text: "All",
        image: "/images/avatars/collection_ava_1.png",
      },
    ],
  });
  const [filterValue, setFilterValue] = useState({
    subCampaign: "",
    impactCategory: "",
  });

  useEffect(() => {
    getAllSubCampaign(id)
      .then(async (res) => {
        setCampaign(res.subCampaigns);
        getFilter();
      })
      .catch((err) => errorToast(err));
  }, []);

  useEffect(() => {
    const { subCampaign, impactCategory } = filterValue;

    let filteredCampaigns = campaign;

    if (subCampaign) {
      filteredCampaigns = filteredCampaigns.filter(
        (item) =>
          item.overview.campaignName.toLowerCase() ===
          subCampaign.value.toLowerCase()
      );
    }

    if (!!impactCategory) {
      filteredCampaigns = filteredCampaigns.filter(
        (item) =>
          item.impact.category.toLowerCase() ===
          impactCategory.value.toLowerCase()
      );
    }

    setFilteredCampaigns(filteredCampaigns);
  }, [campaign, filterValue]);

  const getFilter = async () => {
    const campaignCategory = await getCategory("CAMPAIGN");
    const subCampaign = await getAllSubCampaign(id);

    setFilter({
      ...filter,
      subCampaign: subCampaign?.subCampaigns.map((item, i) => ({
        id: i,
        text: item.overview.campaignName,
        image: "/images/avatars/collection_ava_1.png",
      })),
      impactCategory: campaignCategory?.categoriesList.map((item, i) => ({
        id: i,
        text: item,
        image: "/images/avatars/collection_ava_1.png",
      })),
    });
  };

  return (
    <>
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-1/3 p-4">
          <div className="relative">
            <div>
              <label className="ml-1 font-display text-jacarta-700 mb-2 block dark:text-white">
                Browse By Sub Campaign
              </label>
            </div>

            {/* dropdown */}
            <div className="dropdown my-1 cursor-pointer">
              <Collection_dropdown2
                data={filter.subCampaign}
                collection={true}
              />
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/3 p-4">
          <div className="relative">
            <div>
              <label className="ml-1 font-display text-jacarta-700 mb-2 block dark:text-white">
                Browse by Impact Category
              </label>
            </div>

            {/* dropdown */}
            <div className="dropdown my-1 cursor-pointer">
              <Collection_dropdown2
                data={filter.impactCategory}
                collection={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4">
        {filteredCampaigns.length == 0 ? (
          <p>Loading...</p>
        ) : (
          filteredCampaigns?.map(({ overview, _id }) => {
            return (
              <article key={_id}>
                <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                  <figure className="relative">
                    <Link href={`/campaign/${_id}`}>
                      <Image
                        width={230}
                        height={230}
                        src={baseURL + overview?.bannerImageUrl}
                        alt="item 5"
                        className="w-full h-[230px] rounded-[0.625rem] object-cover"
                      />
                    </Link>
                  </figure>
                  <Link
                    class="font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white"
                    href={`/campaign/${_id}`}
                  >
                    {overview?.campaignName}
                  </Link>
                  <div className="mt-2 flex items-center justify-between text-sm font-medium tracking-tight">
                    <div className="flex flex-wrap items-center">
                      {overview?.description.slice(0, 150)}...
                    </div>
                  </div>
                </div>
              </article>
            );
          })
        )}
      </div>
    </>
  );
}

export default ViewSubCampaigns;
